module.exports = __webpack_public_path__ + "media/images/background_solutions-1440w-d1b48da1.jpg";